import { useQuery } from '@tanstack/react-query';

import { useSelectedPharmacyId } from 'app/hooks';
import { axiosPrivate } from 'app/utils';

async function getOverdueAppointmentsCount({ pharmacyId }) {
  const basePath = '/v3/pharmacist/appointments/overdue/count';
  const queryParams = new URLSearchParams({ pharmacyId });

  const response = await axiosPrivate.get(`${basePath}?${queryParams.toString()}`);
  return response.data;
}

export default function useOverdueAppointmentsCount() {
  const selectedPharmacyId = useSelectedPharmacyId();

  const { data } = useQuery({
    queryKey: ['overdue-appointments-count', selectedPharmacyId],
    queryFn: () => getOverdueAppointmentsCount({ pharmacyId: selectedPharmacyId }),
    enabled: Boolean(selectedPharmacyId),
    meta: {
      errorMessage: 'Failed to fetch overdue appointments count',
    },
  });

  return data?.overdueCount ?? 0;
}
